import DOMPurify from 'dompurify';

export default (param: string) => {
  return DOMPurify.sanitize(param, { USE_PROFILES: { html: true } });
};
